module.exports = __webpack_public_path__ + "static/img/ctk10back.36ed72c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctk10back.png
// module id = ryCU
// module chunks = 5